<template>
	<div class="container__menucardnotifications">
		<div class="container__menucardnotifications__notifications__top">
			<span class="container__menucardnotifications__notifications__top__count">{{
				newNotifications
			}}</span>
			<div class="container__menucardnotifications__notifications__top__notificationinfo">
				<label>{{ nome }}</label>
				<label>Notificações</label>
			</div>
			<div class="container__menucardnotifications__notifications__top__clean">
				<i
					:class="['fas', newNotifications === 0 ? 'fa-check' : 'fa-check-double']"
					@click="setAllVisible"
				/>
			</div>
		</div>
		<div
			v-if="notifications.length"
			class="container__menucardnotifications__notifications__list"
		>
			<div
				v-for="(notification, key) in notifications"
				:key="key"
				:class="[
					'container__menucardnotifications__notifications__list__item',
					{
						'container__menucardnotifications__notifications__list__item--new-notification':
							!notification.visualizado,
					},
				]"
			>
				<div class="container__menucardnotifications__notifications__list__item__icon">
					<i :class="['fas', !notification.visualizado ? 'fa-check-double' : 'fa-check']" />
				</div>
				<div class="container__menucardnotifications__notifications__list__item__info">
					<div class="container__menucardnotifications__notifications__list__item__info__top">
						<label
							class="container__menucardnotifications__notifications__list__item__info__top__title"
							>{{ notification.titulo }}</label
						>
						<label
							class="container__menucardnotifications__notifications__list__item__info__top__date"
							>{{ new Date(notification.dataDaNotificacao).toLocaleDateString() }}</label
						>
					</div>
					<label
						class="container__menucardnotifications__notifications__list__item__info_message"
						>{{ notification.mensagem }}</label
					>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="container__menucardnotifications__semnotificacoes">
				<p>Sem notificações</p>
			</div>
		</div>
	</div>
</template>

<script>
import { mapMutations } from 'vuex'

import * as signalR from '@microsoft/signalr'
import axios from 'axios'

export default {
	data: () => {
		return {
			notifications: [],
			nome: 'Carregando ...',
			urlNotificacoes: process.env.VUE_APP_NOTIFICACOES_URL,
		}
	},
	computed: {
		newNotifications: function () {
			return this.notifications.filter((f) => !f.visualizado).length
		},
	},
	methods: {
		...mapMutations('moduleMessages', ['mutationShowMessage']),
		/**
		 * Busca as notificacoes do usuario na api
		 */
		setNotifications() {
			let email = localStorage.getItem('email')

			let config = {
				headers: { Authorization: localStorage.getItem('jwt') },
			}

			axios
				.get(`${this.urlNotificacoes}/notificacao/buscar-notificacoes-do-usuario/${email}`, config)
				.then((response) => {
					if (response.data) {
						this.nome = response.data.nome
						this.notifications = response.data.notificacoes

						let existemNotificacoesNovas = this.notifications.some((n) => !n.visualizado)
						this.$emit('mudarNotificacao', existemNotificacoesNovas)
					}
				})
		},
		/**
		 * Seta que todas as notificacoes ja foram vistas
		 */
		setAllVisible() {
			this.notifications.forEach((f) => (f.visualizado = true))
			this.$emit('mudarNotificacao', false)

			let email = localStorage.getItem('email')

			let config = {
				headers: { Authorization: localStorage.getItem('jwt') },
			}

			axios.put(
				`${this.urlNotificacoes}/notificacao/setar-notificacoes-como-visualizadas`,
				{ email },
				config,
			)
		},
	},
	async created() {
		this.setNotifications()
		const email = localStorage.getItem('email')
		// withAutomaticReconnect: sem isso, se a conexao caisse (rede/idle/deploy) ela
		// nao voltava — e processamentos longos (~20min) concluiam com o front
		// desconectado, perdendo o push do sino. O grupo NAO sobrevive a uma
		// reconexao, entao re-entramos no grupo a cada (re)conexao.
		const connection = new signalR.HubConnectionBuilder()
			.withUrl(`${this.urlNotificacoes}/notificacoes`)
			.withAutomaticReconnect()
			.build()
		connection.serverTimeoutInMilliseconds = 100000000

		const entrarNoGrupo = () => {
			if (email) connection.invoke('AdicionarClienteAoGrupo', email).catch((e) => console.error(e))
		}
		connection.onreconnected(() => entrarNoGrupo())
		connection.onclose((error) => console.log(error))

		// Recebe push notification neste metodo
		connection.on('NovaNotificacao', (notificacao) => {
			notificacao = Object.assign(notificacao, { visualizado: false })
			this.notifications.unshift(notificacao)
			this.$emit('mudarNotificacao', true)
			this.mutationShowMessage({
				messageTitle: notificacao.titulo,
				messageText: notificacao.mensagem,
				messageIcon: 'far fa-check-circle',
			})
		})

		await connection.start().catch((error) => console.error(error))
		entrarNoGrupo()
	},
}
</script>

<style scoped>
.container__menucardnotifications {
	font-size: 0.75rem;
}

.container__menucardnotifications__notifications__top {
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 1rem 0.5rem;
	background-color: rgb(var(--color-primary));
	box-shadow: 0px 11px 31px -17px rgba(100, 100, 100, 0.5);
}

.container__menucardnotifications__notifications__top__count {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 1.5rem;
	height: 1.5rem;
	margin-left: 1rem;
	color: rgb(var(--color-primary));
	font-weight: 600;
	border-radius: 50%;
	background-color: rgb(var(--color-default));
	transition: background-color 0.5s ease;
}

.container__menucardnotifications__notifications__top__notificationinfo {
	display: flex;
	flex-direction: column;
	width: 80%;
	padding-left: 1rem;
	line-height: 1rem;
}

.container__menucardnotifications__notifications__top__notificationinfo :nth-child(1) {
	color: rgb(var(--color-default));
	font-weight: 600;
	font-size: 0.9rem;
}

.container__menucardnotifications__notifications__top__notificationinfo :nth-child(2) {
	color: white;
	font-weight: 300;
}

.container__menucardnotifications__notifications__top__clean {
	font-size: 1rem;
	width: calc(10% - 2.5rem - 80%);
	color: white;
	cursor: pointer;
}

.container__menucardnotifications__notifications__list {
	width: auto;
	max-height: 50vh;
	overflow-x: hidden;
	overflow-y: auto;
}

.container__menucardnotifications__notifications__list__item {
	display: flex;
	align-items: center;
	padding: 0.5rem 0 0.5rem 1rem;
	background-color: rgba(255, 255, 255, 1);
}

.container__menucardnotifications__notifications__list__item__icon {
	font-size: 1.1rem;
	color: rgba(var(--color-primary), 0.2);
	width: 10%;
	display: flex;
	place-content: center;
}

.container__menucardnotifications__notifications__list__item--new-notification
	.container__menucardnotifications__notifications__list__item__icon {
	color: rgba(var(--color-default));
}

.container__menucardnotifications__notifications__list__item__info {
	display: flex;
	flex-direction: column;
	width: 85%;
	padding: 0 0.5rem;
}

.container__menucardnotifications__notifications__list__item__info__top {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.container__menucardnotifications__notifications__list__item__info__top__title {
	font-weight: 500;
	font-size: 0.7rem;
	color: rgb(var(--color-primary));
	line-height: 1rem;
	filter: blur(0px);
}

.container__menucardnotifications__notifications__list__item--new-notification
	.container__menucardnotifications__notifications__list__item__info__top__title {
	font-weight: 700;
}

.container__menucardnotifications__notifications__list__item__info__top__date {
	font-size: 0.6rem;
	color: rgba(var(--color-primary), 0.6);
	align-self: flex-end;
}

.container__menucardnotifications__notifications__list__item__info_message {
	font-size: 0.7rem;
	color: rgba(var(--color-primary), 0.8);
	line-height: 1rem;
}

.container__menucardnotifications__semnotificacoes {
	background-color: white;
	width: 100%;
	padding: 1rem 1rem 0.3rem 1rem;
	text-align: center;
}

@media screen and (orientation: portrait) and (min-width: 576px) {
	.container__menucardnotifications__notifications__list {
		max-height: 40vh;
	}
}
</style>
